import { operators } from '../../P.StatForm/constants';

export const MODE_TABS = [
  { key: 'HP', label: 'Hardpoint' },
  { key: 'SND', label: 'SND' },
  { key: 'CTL', label: 'Control' },
];

export const WEAPON_ROLE_OPTIONS = [
  { value: 'AR', label: 'Assault Rifles' },
  { value: 'SMG', label: 'Sub-Machine Guns' },
  { value: 'LMG', label: 'Light-Machine Guns' },
  { value: 'SHOTGUN', label: 'Shotgun' },
  { value: 'MARKSMAN', label: 'Marksman' },
  { value: 'SNIPER', label: 'Sniper' },
];

export const ROLE_LIMITS = {
  AR: 3,
  SMG: 3,
  LMG: 1,
  SHOTGUN: 1,
  MARKSMAN: 1,
  SNIPER: 1,
};

export const PLAYER_STATUS_OPTIONS = [
  { value: 'STARTER', label: 'Starter' },
  { value: 'SUB', label: 'Sub' },
];

export const TACTICAL_UTILITY_OPTIONS = [
  'Smoke',
  'Flash',
  'Stun',
  'EMP',
  'Cryo Bomb',
  'Trophy System',
];

export const MODE_FIELDS = {
  HP: ['player', 'status', 'primaryRole', 'secondaryRole', 'operator', 'tacticalOne', 'tacticalTwo'],
  SND: ['player', 'status', 'primaryRole', 'secondaryRole', 'tacticalOne', 'tacticalTwo', 'tacticalThree'],
  CTL: ['player', 'status', 'primaryRole', 'secondaryRole', 'operator', 'tacticalOne', 'tacticalTwo'],
};

export const MODE_EMPTY_ROW = {
  HP: {
    player: '',
    status: 'STARTER',
    primaryRole: '',
    secondaryRole: '',
    operator: '',
    tacticalOne: '',
    tacticalTwo: '',
  },
  SND: {
    player: '',
    status: 'STARTER',
    primaryRole: '',
    secondaryRole: '',
    tacticalOne: '',
    tacticalTwo: '',
    tacticalThree: '',
  },
  CTL: {
    player: '',
    status: 'STARTER',
    primaryRole: '',
    secondaryRole: '',
    operator: '',
    tacticalOne: '',
    tacticalTwo: '',
  },
};

export const OPERATOR_OPTIONS = operators;
